import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef, useEffect } from "react"
import apiResponse from "../../../../services/apiResponse"
import classnames from "classnames"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Modal, ModalBody, ModalFooter, ModalHeader,
    Button,
    Spinner, 
    Input,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane
} from "reactstrap"

import moment from "moment"
import { Link } from 'react-router-dom'

import Select from '../../../../helpers/ui/CustomSelect'

import IndexBloc from './Blocs/IndexBloc'
import TableActiveComponent from './Components/TableComponent'
import TugasTambahanTableComponent from '../../TugasTambahan/Index/Components/TableActiveComponent'

const IndexView = props => {

    let indexBloc = new IndexBloc();

    const [selectedOption, setSelectedOption] = useState([]) 
    const [activeTab, setactiveTab] = useState("1")    
    const [filter, setFilter] = useState([])
    const [optionUnits, setOptionUnits] = useState([]);
    
    const activeRef = useRef();
    const inactiveRef = useRef();

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()
    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        <CardTitle>Peta Jabatan</CardTitle>
                        <hr/>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        active: activeTab === "1",
                                    })}
                                    onClick={() => {
                                        toggle("1")
                                    }}
                                >
                                    <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                    <span className="d-none d-sm-block">Peta Jabatan</span>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        active: activeTab === "2",
                                    })}
                                    onClick={() => {
                                        toggle("2")
                                    }}
                                >
                                    <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                    <span className="d-none d-sm-block">Tugas Tambahan</span>
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab} className="p-3 text-muted">
                            <TabPane tabId="1">
                                <Link to={`/kepegawaian/petajabatan.html?create`}>
                                    <Button color="primary">Tambah Periode</Button>
                                </Link>
                                <hr/>
                                <TableActiveComponent ref={inactiveRef} handleInactiveSuccess={reloadInactiveRef} filter={filter} />
                            </TabPane>
                            <TabPane tabId="2">
                                <Link to={`/kepegawaian/petajabatan.html?create&tugasTambahan`}>
                                    <Button color="primary">Tambah Data</Button>
                                </Link>
                                <hr/>
                                <TugasTambahanTableComponent ref={activeRef} handleInactiveSuccess={reloadActiveRef} />
                            </TabPane>
                        </TabContent>
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    )

}

export default IndexView